import React, { Component,useEffect,useState } from "react";
import PerformanceTable from "./performancetable";
import AssetTable from "./assettable";
import { Link } from 'react-router-dom';

class Performance extends Component {
  render() {
    return (
    <div>
      <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">รู้จักสหกรณ์</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="performance" className="a-breadcrumbs">ผลการดำเนินการ</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                <h2 className="title-section mt-0 mb-0"><span>ผลการดำเนินการ</span></h2><br/>
                <div className="divider gray left mt-20 mb-25" />
                <PerformanceTable />

                <h2 className="title-section mt-0 mb-0"><span>รายการย่อแสดงสินทรัพย์และหนี้สิน</span></h2><br/>
                <div className="divider gray left mt-20 mb-25" />
                <AssetTable />

              </div>
            </div>
          </div>
        </section>
      </div>
      );
  }
}

export default Performance;
